import Carousel from 'Assets/js/lib/carousel'
import { getCartAttributeProperties } from 'Assets/js/lib/form'
import { CARTSTATES, THEME } from 'Assets/js/lib/constants'
import { addItemById } from 'Assets/js/lib/cart'
import { executeGraphQlQuery } from 'Assets/js/lib/product'
import { throttle } from 'Assets/js/lib/helpers'
import { scrollToHandler } from 'Assets/js/lib/smoothscroll'
import { formatMoney } from 'Assets/js/lib/template-helpers'
;(function () {
  const EVENTS = {
    dataFetch: 'productPage:dataFetch',
    fieldsetValidate: 'productPage:fieldsetValidate',
    formSubmit: 'productPage:formSubmit',
    variantChange: 'productPage:variantChange',
    productLoading: 'productPage:loading',
    productChange: 'productPage:productChange',
    lightboxChange: 'productPage:lightboxChange',
  }

  const sortObject = (object) =>
    Object.keys(object)
      .sort()
      // eslint-disable-next-line no-sequences
      .reduce((a, c) => ((a[c] = object[c]), a), {})

  const decodeHTMLEntities = (() => {
    const textArea = document.createElement('textarea')
    return (message) => {
      textArea.innerHTML = message
      return textArea.value
    }
  })()

  let controller = null
  const productPageNextLoad = (nextUrl, suppressPushState = false) => {
    SAXX.App.emit(EVENTS.productLoading)

    if (controller) {
      controller.abort()
    }

    const url = new URL(nextUrl, window.location.origin)
    url.searchParams.set('section_id', 'main-product')

    controller = new AbortController()
    const signal = controller.signal
    fetch(url.toString(), { signal })
      .then((res) => res.text())
      .then((response) => {
        const productPage = new DOMParser().parseFromString(
          response,
          'text/html',
        )

        url.searchParams.delete('section_id')
        if (!suppressPushState) {
          window.history.pushState({}, '', url)
        }

        document.getElementById('mainProductData').remove()

        const script = document.createElement('script')
        script.id = 'mainProductData'
        script.text = productPage.getElementById('mainProductData').innerText
        document.getElementById('mainPageScript').parentNode.appendChild(script)

        SAXX.App.emit(EVENTS.productChange, null, {
          url: url.pathname,
          mobileDetails: productPage.querySelector(
            '.main-product--title-section.main-product--title-section__mobile',
          ),
          desktopDetails: productPage.querySelector(
            '.main-product--title-section.main-product--title-section__desktop',
          ),
          media: productPage.querySelector('.main-product--media.carousel'),
          form: productPage.querySelector('#product-form'),
          mainBuyButton: productPage.querySelector('#main-buy-button'),
          floatingBuyButton: productPage.querySelector('#floating-buy-button'),
        })
        SAXX.App.mount()

        controller = null
      })
      .catch((e) => {
        if (e.name === 'AbortError') return
        console.error(e)
        SAXX.App.emit(EVENTS.productChange)
      })
  }

  const getSelectedVariantData = ({ fields }) => {
    const options = fields.map((element) => {
      if (element.tagName === 'SELECT') {
        return element.value
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find(
          (radio) => radio.checked,
        )?.value
      }

      return undefined
    })

    return SAXX.Product.Data.variants.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return options[index] === option
        })
        .includes(false)
    })
  }

  const components = {
    mainProduct: SAXX.Init.Component((node, ctx) => {
      ctx.on(EVENTS.variantChange, (_, details) => {
        const url = new URL(window.location)
        url.searchParams.set('variant', details.variant.id)
        window.history.replaceState(null, '', url)
      })

      ctx.on(EVENTS.productLoading, () => {
        node.classList.add('loading')
      })

      ctx.on(EVENTS.productChange, (_, details) => {
        node
          .querySelector(
            '.main-product--title-section.main-product--title-section__desktop',
          )
          .replaceWith(details.desktopDetails)
        node
          .querySelector(
            '.main-product--title-section.main-product--title-section__mobile',
          )
          .replaceWith(details.mobileDetails)
        node.querySelector('#product-form').replaceWith(details.form)
        node
          .querySelector('#main-buy-button')
          .replaceWith(details.mainBuyButton)

        document
          .querySelector('#floating-buy-button')
          .replaceWith(details.floatingBuyButton)

        node.classList.remove('loading')
      })

      window.addEventListener('popstate', () => {
        productPageNextLoad(new URL(window.location).toString(), true)
      })
    }),
    mainProductViolators: SAXX.Init.Component((node, ctx) => {
      ctx.on('nosto:postRender', () => {
        node
          .querySelectorAll('.loading-skeleton__text-block')
          .forEach((ele) => ele.remove())
        node.innerHTML = node.innerHTML.trim()
      })

      ctx.on(EVENTS.productChange, () => {
        if (window.nostojs) {
          window.nostojs((api) =>
            api
              .createRecommendationRequest()
              .setElements(['nosto-badges', 'nosto-pdp-badges'])
              .load(),
          )
        }
      })
    }),
    mainProductMedia: SAXX.Init.Component((node, ctx) => {
      new Carousel(node)
      ctx.on(EVENTS.productChange, (_, details) => {
        node.innerHTML = details.media.innerHTML
      })
    }),
    mainProductLightboxCarousel: SAXX.Init.Component((node, ctx) => {
      new Carousel(node)

      ctx.on(EVENTS.lightboxChange, (_, details) => {
        node.dispatchEvent(
          new CustomEvent('select', { detail: { selected: details.selected } }),
        )
      })
    }),
    mainProductLightboxTrigger: SAXX.Init.Component((node, ctx) => {
      node.addEventListener('click', (e) => {
        e.preventDefault()
        const template = document.getElementById(
          `${node.getAttribute('data-lightbox')}`,
        )
        const lightbox = template.content.cloneNode(true)
        const lightboxTarget = template.getAttribute('data-target')

        lightbox.querySelectorAll('[data-lightbox-close]').forEach((node) => {
          node.addEventListener('click', (e) => {
            e.preventDefault()
            const target = document.getElementById(lightboxTarget)
            target.setAttribute('aria-expanded', 'false')
            setTimeout(() => {
              target.remove()
            }, 300)
          })
        })

        lightbox
          .querySelectorAll('.main-product--lightbox-thumbnail')
          .forEach((thumb, i) => {
            thumb.addEventListener('click', () => {
              ctx.emit(EVENTS.lightboxChange, null, { selected: i })
            })
          })

        document.body.appendChild(lightbox)
        SAXX.App.mount()

        setTimeout(() => {
          document
            .getElementById(lightboxTarget)
            .setAttribute('aria-expanded', 'true')
        }, 50)
      })
    }),
    mainProductSpecToggle: SAXX.Init.Component((node) => {
      node.addEventListener('click', () => {
        node.parentNode.classList.toggle('active')
      })
    }),
    mainProductFieldset: SAXX.Init.Component((node, ctx) => {
      ctx.on(EVENTS.fieldsetValidate, () => {
        if (node.disabled) return

        const fieldsetIsInvalid =
          Array.from(
            node.querySelectorAll('input:not([type="hidden"]),select,textarea'),
          ).filter((ele) => !ele.checkValidity()).length > 0

        node.classList.toggle('error', fieldsetIsInvalid)
      })
    }),
    mainProductSwatches: SAXX.Init.Component((node, ctx) => {
      const showAllButton = node.querySelector('[data-show-all]')
      const title = node.querySelector('[data-name]')

      const renderVariantSwatches = (data = {}) => {
        const variants = data[node.getAttribute('data-type')] ?? []
        const colourway = decodeHTMLEntities(SAXX.Product.Colourway)

        node.querySelector('[data-list]').innerHTML = variants.reduce(
          (a, variant, index) => {
            return `${a}<a data-index="${index}" data-pathname="/products/${variant.handle}" class='carousel--cell variant--swatch ${variant.colourway.value === colourway ? 'variant--swatch__active' : ''}' href="/products/${variant.handle}">
                <img alt="Colour Swatch for ${variant.colourway.value}"loading="lazy" src="${variant.image}" width="24" height="24" class="swatch-image" />
                <span class="visually-hidden">View ${variant.colourway.value}</span>
            </a>`
          },
          '',
        )

        node.setAttribute('disabled', variants.length <= 0)

        const name = variants.find(
          (variant) => variant.colourway.value === colourway,
        )
        if (name) {
          title.innerHTML = name.colourway.value
        }

        node.classList.toggle('extra-large-list', variants.length > 50)

        node.querySelector('[data-count]').innerHTML =
          `${variants.length} Colors`

        const initial =
          node
            .querySelector('.variant--swatch__active')
            ?.getAttribute('data-index') ?? 0

        new Carousel(node.querySelector('.carousel'), {
          initial: Number(initial),
        })

        node.querySelectorAll('.variant--swatch').forEach((ele) => {
          ele.addEventListener('click', (e) => {
            e.preventDefault()
            productPageNextLoad(ele.href)
          })

          ctx.on(EVENTS.productChange, (_, details) => {
            ele.classList.toggle(
              'variant--swatch__active',
              details.url === ele.getAttribute('data-pathname'),
            )
          })
        })
      }

      if (SAXX.Product.SessionSwatchData) {
        renderVariantSwatches(
          SAXX.Product.SessionSwatchData[
            `${SAXX.Product.Silhouette} / ${SAXX.Product.PackQuantity}`
          ],
        )
      }

      ctx.on(EVENTS.dataFetch, (_, details) => {
        renderVariantSwatches(
          details[`${SAXX.Product.Silhouette} / ${SAXX.Product.PackQuantity}`],
        )
      })

      ctx.on(EVENTS.productChange, () => {
        const variants =
          SAXX.Product.SessionSwatchData[
            `${SAXX.Product.Silhouette} / ${SAXX.Product.PackQuantity}`
          ][node.getAttribute('data-type')] ?? []
        const colourway = decodeHTMLEntities(SAXX.Product.Colourway)
        const name = variants.find(
          (variant) => variant.colourway.value === colourway,
        )

        title.innerHTML = name ? name.colourway.value : ''
      })

      showAllButton.addEventListener('click', () => {
        node.classList.toggle('expanded')
        showAllButton.innerHTML =
          node.classList.contains('expanded') ? 'Show Less' : 'Show All'
      })
    }),
    mainProductInseamLength: SAXX.Init.Component((node, ctx) => {
      const renderInseamLength = (data) => {
        const relatedInseamLength = Object.entries(
          data.relatedInseamLength ?? {},
        )

        node.parentElement.setAttribute(
          'disabled',
          relatedInseamLength.length <= 1,
        )

        node.querySelector('[data-list]').innerHTML =
          relatedInseamLength.reduce((a, [key, value]) => {
            return `${a}<div class='input--swatch'>
              <a
                href='/products/${value}'
                class='input--swatch-link ${key === SAXX.Product.InseamLength ? 'active' : ''}'
                >${key}</a
              >
            </div>`
          }, '')
      }

      if (SAXX.Product.SessionSwatchData) {
        renderInseamLength(SAXX.Product.SessionSwatchData)
      }

      ctx.on(EVENTS.dataFetch, (_, details) => {
        renderInseamLength(details)
      })
    }),
    mainProductMultiPacks: SAXX.Init.Component((node, ctx) => {
      const renderMultiPacks = (data) => {
        const relatedPackageQuantity = Object.entries(
          data.relatedPackageQuantity[SAXX.Product.Silhouette] ?? {},
        )

        node.parentElement.setAttribute(
          'disabled',
          relatedPackageQuantity.length <= 1,
        )

        node.querySelector('[data-list]').innerHTML =
          relatedPackageQuantity.reduce((a, [key, value]) => {
            const name = key === '1 Pack' ? 'Single' : key
            return `${a}<div class='input--swatch'>
              <a
                href='/products/${value}'
                class='input--swatch-link ${name === SAXX.Product.PackQuantity ? 'active' : ''}'
                >${name}</a
              >
            </div>`
          }, '')
      }

      if (SAXX.Product.SessionSwatchData) {
        renderMultiPacks(SAXX.Product.SessionSwatchData)
      }

      ctx.on(EVENTS.dataFetch, (_, details) => {
        renderMultiPacks(details)
      })
    }),
    mainProductBuyButton: SAXX.Init.Component((node, ctx) => {
      ctx.on(EVENTS.variantChange, (_, details) => {
        node.disabled = !details.variant.available
        node.querySelector('.button-text').innerHTML =
          details.variant.available ? `Add To Cart` : 'Out of stock'
      })

      node.addEventListener('click', (e) => {
        if (node.disabled || !node.form.checkValidity()) {
          e.preventDefault()

          if (node.id === 'floating-primary__add-to-cart') {
            scrollToHandler('#product-form')
          }

          ctx.emit(EVENTS.fieldsetValidate)
        }
      })
    }),
    mainProductBuyButtonPrice: SAXX.Init.Component((node, ctx) => {
      ctx.on(EVENTS.variantChange, (_, details) => {
        const regularPrice = formatMoney(details.variant.price, true)

        node.innerHTML = details.variant.available ? ` - ${regularPrice}` : ''
      })
    }),
    mainProductWaitlist: SAXX.Init.Component((node) => {
      const klaviyoId = node.getAttribute('data-id')
      node.addEventListener('click', () => {
        window._klOnsite = window._klOnsite || []
        window._klOnsite.push(['openForm', klaviyoId])
      })
    }),
    mainProductFloatingBuyButton: SAXX.Init.Component((node, ctx) => {
      const primaryAddToCart = document.querySelector('#primary__add-to-cart')

      const getOffsetTop = () => {
        return (
          window.scrollY -
          window.innerHeight +
          document.querySelector('.site-navigation').clientHeight
        )
      }

      window.addEventListener(
        'scroll',
        throttle(() => {
          node.classList.toggle(
            'active',
            getOffsetTop() > primaryAddToCart.offsetTop,
          )

          document
            .querySelector(':root')
            .style.setProperty(
              '--floating-action-button-base-offset',
              getOffsetTop() > primaryAddToCart.offsetTop ? '5.625rem' : '0rem',
            )
        }, 150),
      )
    }),
    mainProductForm: SAXX.Init.Component((node, ctx) => {
      const toggleInputGroupState = (id, state) => {
        const targetFieldset = document.getElementById(id)

        targetFieldset.disabled = !state
        targetFieldset
          .querySelectorAll('input:not([type="hidden"]),textarea')
          .forEach((ele) => {
            ele.disabled = !state
          })
      }

      const mainProductFormChangeEvent = (
        { target = null } = { target: null },
      ) => {
        ctx.emit(EVENTS.fieldsetValidate)

        const disableToggleTargets = Array.from(
          node.querySelectorAll('[data-disable-target]'),
        )
        const formInputs = Array.from(node.querySelectorAll('select, fieldset'))
        const variantInput = node.querySelector('input[name="id"]')
        const variant = getSelectedVariantData({ fields: formInputs })
        const disableToggle = disableToggleTargets.find((ele) => ele === target)

        if (disableToggle) {
          toggleInputGroupState(
            disableToggle.getAttribute('data-disable-target'),
            disableToggle.checked,
          )
        }

        if (!variant) return

        variantInput.value = variant.id

        ctx.emit(EVENTS.variantChange, null, { variant })
      }

      node.addEventListener('change', mainProductFormChangeEvent)

      node.addEventListener('submit', async (e) => {
        e.preventDefault()

        const formData = new FormData(node)
        const variantID = formData.get('id')
        const quantity = formData.get('quantity')
        const properties = getCartAttributeProperties(formData)
        const response = await addItemById(variantID, quantity, properties)

        ctx.emit(THEME.drawerControlInteraction, null, {
          controlElement: 'slide-out-cart',
        })

        if (!response || response.status === 422) {
          return ctx.emit(CARTSTATES.UPDATINGERROR, null, {
            cart: response,
          })
        }

        ctx.emit(CARTSTATES.UPDATED, null, {
          addedLineItems: response.items,
          cart: response,
        })
      })

      ctx.on(EVENTS.productChange, () => {
        if (
          typeof window.bwp === 'object' &&
          typeof window.bwp.updateWidget === 'function'
        ) {
          window.bwp.updateWidget(SAXX.Product.SelectedVariant.sku, 1)
        }
      })

      ctx.on(EVENTS.variantChange, (_, details) => {
        if (
          typeof window.bwp === 'object' &&
          typeof window.bwp.updateWidget === 'function'
        ) {
          window.bwp.updateWidget(details.variant.sku, 1)
        }
      })
    }),
    mainProductLocally: SAXX.Init.Component((node, ctx) => {
      const locally = () => {
        const locallyEndpoint = new URL(
          'https://saxx.locally.com/stores/map.js',
        )
        Object.entries(SAXX.Product.Locally).forEach(([key, value]) => {
          locallyEndpoint.searchParams.append(key, value)
        })

        const script = document.createElement('script')
        script.src = locallyEndpoint.toString()

        const locallyLink = document.createElement('a')
        locallyLink.id = 'lcly-link-0'
        locallyLink.role = 'button'
        locallyLink.href = ''
        locallyLink.target = '_blank'
        locallyLink.classList.add('visually-hidden')
        locallyLink.innerText = 'Product Locator by Locally'
        locallyLink.setAttribute('data-switchlive', 'true')
        locallyLink.setAttribute('data-switchlive-mode', 'auto')
        locallyLink.setAttribute('data-switchlive-id-PL', '6')

        document.getElementById('lcly-button-0').innerHTML = ''
        document.getElementById('lcly-button-0').append(locallyLink)
        node.innerHTML = ''
        node.append(script)
      }

      locally()

      ctx.on(EVENTS.productChange, () => {
        locally()
      })
    }),
    mainProductStyleCode: SAXX.Init.Component((node, ctx) => {
      ctx.on(EVENTS.productChange, () => {
        node.innerHTML = SAXX.Product.StyleCode
      })
    }),
    sizeGuideFitRows: SAXX.Init.Component((node) => {
      new Carousel(node)
    }),
  }

  SAXX.Init.AddComponents(components)

  SAXX.Init.Callbacks.push(() => {
    return () => {
      if (SAXX.Product.SessionSwatchData) return

      if (SAXX.Product.Collection === '') {
        SAXX.App.emit(EVENTS.dataFetch, null, {
          id: null,
          relatedInseamLength: {},
          relatedPackageQuantity: {},
        })
        return
      }

      executeGraphQlQuery(
        SAXX.Shop.APIKey,
        `query ($id: ID!, $filter: [ProductFilter!]) {
            collection(id: $id) {
            products(first: 200, filters: $filter) {
              nodes {
                handle
                colourway: metafield(namespace: "colourway", key: "primary") {
                  value
                }
                swatch: metafield(namespace: "content", key: "swatch") {
                  reference {
                    ... on MediaImage {
                      image {
                        url(transform: {maxWidth: 72})
                      }
                    }
                  }
                }
                featuredImage {
                  url(transform: {maxWidth: 72})
                }
                silhouette: metafield(namespace: "silhouette", key: "primary") {
                  value
                }
                packageQuantity: metafield(namespace: "package", key: "quantity") {
                  value
                }
                inseam: metafield(namespace: "inseam", key: "length") {
                  value
                }
                print: metafield(namespace: "print", key: "style") {
                  value
                }
                hidden: metafield(namespace: "seo", key: "hidden") {
                  value
                }
              }
            }
          }
        }`,
        {
          id: SAXX.Product.Collection,
          filter: SAXX.Product.SwatchRequestFilter,
        },
      )
        .then((res) => {
          if (res.errors) {
            throw new Error(res.errors[0].message)
          }

          const swatchObject = {
            id: SAXX.Product.Collection,
            relatedInseamLength: {},
            relatedPackageQuantity: {},
          }

          res.data.collection.products.nodes?.forEach((product) => {
            if (
              product.hidden?.value === '1' ||
              product.silhouette === null ||
              product.packageQuantity === null
            )
              return

            const grouping = `${product.silhouette.value} / ${product.packageQuantity.value}`

            const sil = swatchObject[grouping] ?? {
              solid: [],
              pattern: [],
            }

            const type = product.print?.value.toLowerCase() ?? 'solid'

            product.image =
              product.swatch?.reference.image.url ??
              product.featuredImage?.url ??
              ''

            sil[type].push(product)

            swatchObject[grouping] = sil

            if (
              product.inseam !== null &&
              product.packageQuantity.value === 'Single' &&
              !swatchObject.relatedInseamLength[product.inseam.value]
            ) {
              swatchObject.relatedInseamLength[product.inseam.value] =
                product.handle
            }

            swatchObject.relatedPackageQuantity[product.silhouette.value] =
              swatchObject.relatedPackageQuantity[product.silhouette.value] ??
              {}

            if (
              !swatchObject.relatedPackageQuantity[product.silhouette.value][
                product.packageQuantity.value
              ]
            ) {
              const quantity =
                product.packageQuantity.value === 'Single' ?
                  '1 Pack'
                : product.packageQuantity.value
              swatchObject.relatedPackageQuantity[product.silhouette.value][
                quantity
              ] = product.handle
            }
          })

          swatchObject.relatedInseamLength = sortObject(
            swatchObject.relatedInseamLength,
          )

          Object.keys(swatchObject.relatedPackageQuantity).forEach(
            (key) =>
              (swatchObject.relatedPackageQuantity[key] = sortObject(
                swatchObject.relatedPackageQuantity[key],
              )),
          )

          SAXX.Session.StoredProductSwatches.push(swatchObject)
          sessionStorage.setItem(
            'storedProductSwatches',
            JSON.stringify(SAXX.Session.StoredProductSwatches),
          )

          SAXX.App.emit(EVENTS.dataFetch, null, swatchObject)
        })
        .catch((e) => {
          console.error(e)
          SAXX.App.emit(EVENTS.dataFetch, null, {
            id: SAXX.Product.Collection,
            relatedInseamLength: {},
            relatedPackageQuantity: {},
          })
        })
    }
  })
})()
